import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ICompanyState {
  currentCompanyId: string | undefined;
  showCompanyEditor: boolean;
}

const initialState: ICompanyState = {
  currentCompanyId: undefined,
  showCompanyEditor: false,
};

export const companySlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    showCompanyEditor: (state, action: PayloadAction<string | undefined>) => {
      state.showCompanyEditor = true;
      state.currentCompanyId = action.payload;
    },
    hideCompanyEditor: (state) => {
      state.showCompanyEditor = false;
      state.currentCompanyId = undefined;
    }
  },
});

export const { showCompanyEditor, hideCompanyEditor } = companySlice.actions;
export const authReducer = companySlice.reducer;
